export default {
  page_title: '其他 LII 及資源',
  t_falm: 'FALM 成員',
  t_clic: '社區法網 (CLIC)',
  clicname: 'Community Legal Information Centre',
  liis: [
    "HKLII 參與{0}，參與機構包括：",
    "社區法網是一個雙語法律資訊互聯網站，市民可透過此網站迅速地尋找有關香港法律的資料。社區法網是由香港大學法律與科技研究中心承辦，並由香港特區政府律政司撥款。"
  ],
  fatlm: "法律信息自由取用運動"
}